import React from 'react';
import { List } from 'react-virtualized';
import { Grid } from '@mui/material';

const VirtualProductsList = ({
  products,
  productKeys,
  rowHeight,
  width,
  height,
  onSelectProduct
}) => {
  const rowRenderer = ({
    key, // Unique key within array of rows
    index, // Index of row within collection
    style // Style object to be applied to row (to position it)
  }) => {
    const product = products[productKeys[index]];
    if (product) {
      return (
        <div
          key={key}
          style={style}
          className="flex justify-center items-center cursor-pointer hover:bg-gray-200"
          onClick={() => {
            onSelectProduct(product);
          }}>
          <Grid container>
            <Grid
              item
              xs={2}
              className="flex justify-center items-center">
              <img
                alt={product.productName}
                src={product.image}
                className="h-10 w-10 mt-5 ml-2"
              />
            </Grid>
            <Grid item xs={8}>
              <div className="py-3 pr-0 pl-2">
                <p className="inline">{product.productName}</p>
                <p className="inline"> | {product.storeName}</p>
              </div>
            </Grid>
          </Grid>
        </div>
      );
    } else {
      return null;
    }
  };

  return (
    <div className="p-2.5">
      <List
        className="outline-none"
        width={width}
        height={height}
        rowCount={productKeys.length}
        rowHeight={rowHeight}
        rowRenderer={rowRenderer}
      />
    </div>
  );
};

export default VirtualProductsList;
